import type { CanvasBridge } from '@frontendlib/boards-canvas';

interface FitApi {
  refresh(): void;
  getSceneElements(): readonly { isDeleted?: boolean }[];
  scrollToContent(elements: unknown, options: object): void;
}

/**
 * Fits the live content into view (prototype `BoardPanelRecord.tsx:50`: `refresh()` then `scrollToContent(..., { fitToContent, viewportZoomFactor: .75,
 * maxZoom: 1 })`; the editor's "Fit board", `Boards.tsx:303`). Only the viewport moves; the scene is not written. Returns false when there is nothing to fit.
 */
export function fitBoardToContent(bridge: CanvasBridge | undefined): boolean {
  if (!bridge || bridge.isDisposed) return false;
  const api = bridge.excalidrawApi as FitApi | undefined;
  if (!api) return false;
  api.refresh();
  api.scrollToContent(api.getSceneElements().filter((item) => !item.isDeleted), { fitToContent: true, viewportZoomFactor: 0.75, maxZoom: 1 });
  return true;
}
